import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { FeedbackService } from '../feedback.service'

@Component({
  standalone: false,
  selector: 'vs-loggedin-feedback-form',
  templateUrl: './loggedin-feedback-form.component.html',
  styleUrls: ['./loggedin-feedback-form.component.scss'],
})
export class LoggedinFeedbackFormComponent implements OnInit {
  attachmentFiles: any
  loginFeedbackForm: FormGroup
  maxSubjectMessageLength: number = 500
  content: any = ''
  isSubmitted: boolean = false
  subjectDropdownContents: any = []
  firstNameFetched: string
  lastNameFetched: string
  emailAddressFetched: String
  uidFetched: string
  loaderActivated: boolean = false

  constructor(
    private formBuilder: FormBuilder,
    private globalMessageService: GlobalMessageService,
    private feedbackService: FeedbackService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loaderActivated = true
    this.createForm()
    this.fetchFeedbackFormDetails()
  }
  createForm() {
    this.loginFeedbackForm = this.formBuilder.group({
      subjectChosen: new FormControl('', Validators.required),
      subjectMessage: new FormControl('', [
        Validators.required,
        Validators.maxLength(this.maxSubjectMessageLength),
      ]),
    })
  }

  checkLength(event) {
    this.content = event.target.value
  }

  updateFile(event) {
    this.attachmentFiles = event
  }

  removedFile(event) {
    let fileName: string = event
    let refreshFilesList = []
    if (this.attachmentFiles.length > 0) {
      for (let i = 0; i < this.attachmentFiles.length; i++) {
        if (
          this.attachmentFiles[i].name.trim().toString() !==
          fileName.trim().toString()
        ) {
          refreshFilesList.push(this.attachmentFiles[i])
        }
      }
    }
    this.attachmentFiles = refreshFilesList
  }

  uploadFiles() {
    const formData = new FormData()
    this.attachmentFiles.forEach((element) => {
      formData.append('multipartFile', element)
    })
  }

  fetchFeedbackFormDetails() {
    this.feedbackService.fetchDetailsFeedbackForm().subscribe(
      (response) => {
        if (response !== null && response !== undefined) {
          this.loaderActivated = false
          this.subjectDropdownContents = response['subject']
          if (
            this.subjectDropdownContents !== undefined &&
            this.subjectDropdownContents.length > 0 &&
            this.subjectDropdownContents[0].code !== undefined
          ) {
            this.loginFeedbackForm.controls['subjectChosen'].setValue(
              this.subjectDropdownContents[0].code
            )
          }
          this.firstNameFetched = response['firstName']
          this.lastNameFetched = response['lastName']
          this.emailAddressFetched = response['email']
          this.uidFetched = response['uid']
        } else {
          this.loaderActivated = false
          this.displayFeedbackFormLoadError()
        }
      },
      (error) => {
        this.loaderActivated = false
        this.displayFeedbackFormLoadError()
      }
    )
  }

  displayFeedbackFormLoadError() {
    this.globalMessageService.add(
      { key: 'help.issueFeedbackForm' },
      GlobalMessageType.MSG_TYPE_ERROR,
      5000
    )
    window.scrollTo(0, 0)
  }

  submitFeedback() {
    this.isSubmitted = true

    if (this.loginFeedbackForm.valid) {
      const formData = new FormData()

      formData.append(
        'subjectTypeCode',
        this.loginFeedbackForm.controls['subjectChosen'].value
      )
      formData.append(
        'message',
        this.loginFeedbackForm.controls['subjectMessage'].value
      )
      if (
        this.attachmentFiles !== null &&
        this.attachmentFiles !== undefined &&
        this.attachmentFiles.length > 0
      ) {
        this.attachmentFiles.forEach((element) => {
          formData.append('multipartFile', element)
        })
      }
      this.loaderActivated = true
      this.feedbackService.submitLoggedinUserFeedback(formData).subscribe(
        (response) => {
          this.resetScreen()
          this.loaderActivated = false
          this.globalMessageService.add(
            { key: 'help.thanksForFeedback' },
            GlobalMessageType.MSG_TYPE_CONFIRMATION,
            5000
          )
          window.scrollTo(0, 0)
        },
        (error) => {
          this.resetScreen()
          this.loaderActivated = false
          this.globalMessageService.add(
            { key: 'help.issueWhileSubmitFeedback' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
    }
  }

  resetScreen() {
    this.isSubmitted = false
    this.attachmentFiles = []
    this.loginFeedbackForm.reset()
    this.loginFeedbackForm.markAsPristine()
    this.loginFeedbackForm.markAsUntouched()
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/feedback'])
    })
  }
}
